export default __webpack_public_path__ + "static/media/oub2.0191e601.jpeg";